import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=51cea19b&lang=pug"
import script from "./Deal.vue?vue&type=script&lang=js"
export * from "./Deal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports